import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangFrIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 18,
	viewBox: "0 0 18 18",
	width: 18,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z",
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.998 9a9.003 9.003 0 0 0-5.87-8.44v16.88A9.003 9.003 0 0 0 17.999 9z",
			fill: "#d80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 9a9.003 9.003 0 0 0 5.87 8.44V.56A9.003 9.003 0 0 0 0 9z",
			fill: "#0052b4"
		})
	]
});
const ForwardRef = forwardRef(SvgLangFrIconmin);
export { ForwardRef as ReactComponent };
